import {
  Column,
  DataGrid,
  FilterRow,
  Item,
  Toolbar,
} from "devextreme-react/data-grid";
import { Popup } from "devextreme-react/popup";
import { useTranslation } from "react-i18next";
import { CalculateWorkingTimeSummaryResult } from "../../../types";

type CalculateWorkingTimeSummaryResultDialogProps = {
  calculateWorkingTimeSummaryResults:
    | CalculateWorkingTimeSummaryResult[]
    | undefined;
  year: number;
  month: number;
  onClose: () => void;
};

export default function CalculateWorkingTimeSummaryResultDialog({
  calculateWorkingTimeSummaryResults,
  year,
  month,
  onClose,
}: CalculateWorkingTimeSummaryResultDialogProps) {
  const { t } = useTranslation();

  return (
    <Popup
      visible
      title={t("presence.calculateWorkingTimePopup.title")}
      onHiding={onClose}
      maxWidth={900}
      height="auto"
      maxHeight="80vh"
      showCloseButton
      dragEnabled
    >
      {calculateWorkingTimeSummaryResults === undefined ? (
        t("common.noData")
      ) : calculateWorkingTimeSummaryResults.length === 0 ? (
        t("presence.calculateWorkingTimePopup.noMatchingData")
      ) : (
        <>
          <div>{t("presence.calculateWorkingTimePopup.resultMessage")}</div>
          <DataGrid
            dataSource={calculateWorkingTimeSummaryResults}
            showBorders
            allowColumnResizing
            allowColumnReordering
            searchPanel={{
              visible: true,
              placeholder: t("searchPlaceholder"),
            }}
            paging={{
              pageSize: 10,
            }}
            pager={{
              visible: true,
              showInfo: true,
              showNavigationButtons: true,
            }}
          >
            <Toolbar>
              <Item
                name="searchPanel"
                location="before"
                locateInMenu="auto"
                cssClass="datagrid-search-panel-without-margin-left"
              />
            </Toolbar>
            <FilterRow visible />
            <Column
              dataField="employeeFullName"
              caption={t(
                "presence.calculateWorkingTimePopup.datagrid.employee",
              )}
            />
            <Column
              dataField="civilContractNumber"
              caption={t(
                "presence.calculateWorkingTimePopup.datagrid.civilContractNumber",
              )}
              width={200}
              alignment="center"
            />
            <Column
              caption={t(
                "presence.calculateWorkingTimePopup.datagrid.yearAndMonth",
              )}
              width={150}
              alignment="center"
              cellRender={() => `${year}/${month.toString().padStart(2, "0")}`}
            />
            <Column
              dataField="timeInMinutes"
              caption={t("presence.calculateWorkingTimePopup.datagrid.time")}
              width={100}
              alignment="center"
              customizeText={(cellInfo) => {
                const totalMinutes = cellInfo.value ?? 0;
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                return `${hours}:${minutes.toString().padStart(2, "0")}`;
              }}
            />
          </DataGrid>
        </>
      )}
    </Popup>
  );
}
